import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { createSelector, Store } from '@ngrx/store';

import { FreyaCommonModule } from 'src/app/freya-common/freya-common.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { LoadingState } from 'src/app/utilities/state.util';

import { UserPageMergeConflictDialogComponent } from '../user-page-merge-conflict-dialog/user-page-merge-conflict-dialog.component';

import { UserPageSimilarCustomersActions } from './user-page-similar-customers.actions';
import { userPageSimilarCustomersFeature } from './user-page-similar-customers.feature';
import { selectSimilarCustomersWithMatch } from './user-page-similar-customers.selectors';

@Component({
    selector: 'app-user-page-similar-customers',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        FreyaCommonModule,
        SharedModule,
        UserPageMergeConflictDialogComponent,
    ],
    templateUrl: './user-page-similar-customers.component.html',
    styleUrls: ['./user-page-similar-customers.component.scss'],
})
export class UserPageSimilarCustomersComponent {

    viewModel$ = this.store.select(createSelector({
        rows: selectSimilarCustomersWithMatch,
        loading: createSelector(
          userPageSimilarCustomersFeature.selectLoading,
          (loading) => loading === LoadingState.LOADING,
        ),
        search: userPageSimilarCustomersFeature.selectSearch,
    }));

    actions = UserPageSimilarCustomersActions;

    constructor(public store: Store) {}
}
